import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { adminAlerts, adminDismissAlert } from "../../lib/adminApi";

export default function AdminAlerts() {
  const [alerts, setAlerts] = useState([]);
  const [type, setType] = useState("all");

  const load = () => adminAlerts().then((d) => setAlerts(d.alerts));
  useEffect(() => { load(); }, []);

  const types = ["all", ...Array.from(new Set(alerts.map((a) => a.type)))];
  const filtered = type === "all" ? alerts : alerts.filter((a) => a.type === type);

  const dismiss = async (id) => { await adminDismissAlert(id); load(); };

  return (
    <div className="px-5 md:px-10 py-8 max-w-6xl" data-testid="admin-alerts">
      <header className="mb-6">
        <p className="overline text-[#C17F59] mb-2">Alerts</p>
        <h1 className="font-display text-4xl">{alerts.length} signals · {filtered.length} shown.</h1>
      </header>

      <div className="flex gap-1 mb-5 border-b border-white/8 overflow-x-auto no-scrollbar">
        {types.map((t) => (
          <button key={t} onClick={() => setType(t)}
                  className={`text-xs uppercase tracking-[0.22em] px-3 py-2 ${type === t ? "text-[#C17F59] border-b border-[#C17F59]" : "text-white/50 hover:text-white"}`}
                  data-testid={`alert-tab-${t}`}>
            {t}
          </button>
        ))}
      </div>

      <div className="space-y-3">
        {filtered.map((a, i) => (
          <div key={`${a.id}-${i}`} className="bg-[#15171A] border border-white/8 p-4 flex items-start gap-4" data-testid={`alert-${a.id}`}>
            <div className="flex-1">
              <p className={`overline mb-1 ${a.severity === "high" ? "text-red-400" : a.severity === "medium" ? "text-yellow-400" : "text-white/50"}`}>
                {a.severity || "low"} · {a.type}
              </p>
              <p className="font-display text-lg leading-snug">{a.title}</p>
              {a.detail && <p className="text-sm text-white/55 mt-1">{a.detail}</p>}
            </div>
            <div className="flex flex-col gap-2 shrink-0">
              {a.gin_id && (
                <Link to={`/admin/menu/${a.gin_id}`} className="text-xs uppercase tracking-[0.22em] text-[#C17F59] hover:text-[#D89A74]">
                  Open gin →
                </Link>
              )}
              {a.persisted && (
                <button onClick={() => dismiss(a.id)} className="text-xs uppercase tracking-[0.22em] text-white/50 hover:text-white" data-testid={`dismiss-${a.id}`}>
                  Dismiss
                </button>
              )}
            </div>
          </div>
        ))}
        {filtered.length === 0 && <p className="text-white/50">No alerts in this bucket.</p>}
      </div>
    </div>
  );
}
